/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CatalogInstallationDto } from '../model/catalogInstallationDto';
import { CatalogSubmissionDto } from '../model/catalogSubmissionDto';
import { InstallRequest } from '../model/installRequest';
import { InstallationOverviewDto } from '../model/installationOverviewDto';
import { InstalledPackageDto } from '../model/installedPackageDto';
import { JsonNode } from '../model/jsonNode';
import { LinkRequest } from '../model/linkRequest';
import { PreflightRequest } from '../model/preflightRequest';
import { PreflightResultDto } from '../model/preflightResultDto';
import { RejectRequest } from '../model/rejectRequest';
import { Targets } from '../model/targets';
import { UnlinkedDto } from '../model/unlinkedDto';
import { UnlinkedRevokeRequest } from '../model/unlinkedRevokeRequest';
import { UsageDto } from '../model/usageDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdminMyCheckKatalogService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Nie benutzten Eintrag in dieser Stage hart löschen
     * Kopien, Freigabe, Installation und Einreichungen; benutzt → 409 mit usage; ohne Installation und Einreichungen ebenfalls 204
     * @param catalogKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public delete3(catalogKey: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public delete3(catalogKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public delete3(catalogKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public delete3(catalogKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (catalogKey === null || catalogKey === undefined) {
            throw new Error('Required parameter catalogKey was null or undefined when calling delete3.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/admin/catalog/installations/${encodeURIComponent(String(catalogKey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Paket einer Einreichung abholen
     * Setzt die Einreichung auf FETCHED
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fetchPackage(id: string, observe?: 'body', reportProgress?: boolean): Observable<JsonNode>;
    public fetchPackage(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JsonNode>>;
    public fetchPackage(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JsonNode>>;
    public fetchPackage(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fetchPackage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<JsonNode>('get',`${this.basePath}/admin/catalog/submissions/${encodeURIComponent(String(id))}/package`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Katalog-Version installieren
     * Idempotent je (catalogKey, version); andere Version &#x3D; Update an Ort und Stelle; 422 mit findings bei BLOCKER
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public install(body: InstallRequest, observe?: 'body', reportProgress?: boolean): Observable<CatalogInstallationDto>;
    public install(body: InstallRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogInstallationDto>>;
    public install(body: InstallRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogInstallationDto>>;
    public install(body: InstallRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling install.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CatalogInstallationDto>('post',`${this.basePath}/admin/catalog/install`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Frisches Paket des installierten Stands
     * Grundlage für „Nach live übernehmen“; sha256 ändert sich nur mit dem Inhalt
     * @param catalogKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public installedPackage(catalogKey: string, observe?: 'body', reportProgress?: boolean): Observable<InstalledPackageDto>;
    public installedPackage(catalogKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InstalledPackageDto>>;
    public installedPackage(catalogKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InstalledPackageDto>>;
    public installedPackage(catalogKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (catalogKey === null || catalogKey === undefined) {
            throw new Error('Required parameter catalogKey was null or undefined when calling installedPackage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InstalledPackageDto>('get',`${this.basePath}/admin/catalog/installations/${encodeURIComponent(String(catalogKey))}/package`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vorhandene Kopie einem Katalog-Eintrag zuordnen (Version 0)
     * Idempotent; 422 mit findings bei BLOCKER im Strukturvergleich, WARNINGs im Feld findings der Antwort
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public link(body: LinkRequest, observe?: 'body', reportProgress?: boolean): Observable<CatalogInstallationDto>;
    public link(body: LinkRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogInstallationDto>>;
    public link(body: LinkRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogInstallationDto>>;
    public link(body: LinkRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling link.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CatalogInstallationDto>('post',`${this.basePath}/admin/catalog/link`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Installationen dieser Stage mit Namen, enthaltenen myChecks und letztem Changelog
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listInstallations(observe?: 'body', reportProgress?: boolean): Observable<Array<InstallationOverviewDto>>;
    public listInstallations(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InstallationOverviewDto>>>;
    public listInstallations(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InstallationOverviewDto>>>;
    public listInstallations(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<InstallationOverviewDto>>('get',`${this.basePath}/admin/catalog/installations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Einreichungen dieser Stage
     * status&#x3D;OPEN|FETCHED|REJECTED; ohne Angabe alle
     * @param status 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSubmissions(status?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CatalogSubmissionDto>>;
    public listSubmissions(status?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CatalogSubmissionDto>>>;
    public listSubmissions(status?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CatalogSubmissionDto>>>;
    public listSubmissions(status?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CatalogSubmissionDto>>('get',`${this.basePath}/admin/catalog/submissions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zentrale Bereitstellungen dieser Stage ohne Katalog-Installation
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listUnlinked(observe?: 'body', reportProgress?: boolean): Observable<Array<UnlinkedDto>>;
    public listUnlinked(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UnlinkedDto>>>;
    public listUnlinked(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UnlinkedDto>>>;
    public listUnlinked(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UnlinkedDto>>('get',`${this.basePath}/admin/catalog/unlinked`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vorprüfung gegen diese Stage
     * Schreibt nichts
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public preflight(body: PreflightRequest, observe?: 'body', reportProgress?: boolean): Observable<PreflightResultDto>;
    public preflight(body: PreflightRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PreflightResultDto>>;
    public preflight(body: PreflightRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PreflightResultDto>>;
    public preflight(body: PreflightRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling preflight.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PreflightResultDto>('post',`${this.basePath}/admin/catalog/preflight`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Einreichung ablehnen
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reject(id: string, body?: RejectRequest, observe?: 'body', reportProgress?: boolean): Observable<CatalogSubmissionDto>;
    public reject(id: string, body?: RejectRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogSubmissionDto>>;
    public reject(id: string, body?: RejectRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogSubmissionDto>>;
    public reject(id: string, body?: RejectRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling reject.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CatalogSubmissionDto>('post',`${this.basePath}/admin/catalog/submissions/${encodeURIComponent(String(id))}/reject`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Installation zurückziehen
     * Freigabe aufheben, Kopien archivieren
     * @param catalogKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public revoke(catalogKey: string, observe?: 'body', reportProgress?: boolean): Observable<CatalogInstallationDto>;
    public revoke(catalogKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogInstallationDto>>;
    public revoke(catalogKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogInstallationDto>>;
    public revoke(catalogKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (catalogKey === null || catalogKey === undefined) {
            throw new Error('Required parameter catalogKey was null or undefined when calling revoke.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CatalogInstallationDto>('post',`${this.basePath}/admin/catalog/installations/${encodeURIComponent(String(catalogKey))}/revoke`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Bereitstellung ohne Katalog-Gegenstück zurückziehen
     * Freigabe aufheben bzw. DIRECT-Ziele entfernen, Kopie archivieren; 204, idempotent
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public revokeUnlinked(body: UnlinkedRevokeRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public revokeUnlinked(body: UnlinkedRevokeRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public revokeUnlinked(body: UnlinkedRevokeRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public revokeUnlinked(body: UnlinkedRevokeRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling revokeUnlinked.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/admin/catalog/unlinked/revoke`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Zielgruppe einer Installation ersetzen
     * 
     * @param body 
     * @param catalogKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTargets(body: Targets, catalogKey: string, observe?: 'body', reportProgress?: boolean): Observable<CatalogInstallationDto>;
    public updateTargets(body: Targets, catalogKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CatalogInstallationDto>>;
    public updateTargets(body: Targets, catalogKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CatalogInstallationDto>>;
    public updateTargets(body: Targets, catalogKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTargets.');
        }

        if (catalogKey === null || catalogKey === undefined) {
            throw new Error('Required parameter catalogKey was null or undefined when calling updateTargets.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CatalogInstallationDto>('put',`${this.basePath}/admin/catalog/installations/${encodeURIComponent(String(catalogKey))}/targets`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Nutzung eines Eintrags in dieser Stage
     * Ohne Installation 200 mit used&#x3D;false und lauter Nullen
     * @param catalogKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usage(catalogKey: string, observe?: 'body', reportProgress?: boolean): Observable<UsageDto>;
    public usage(catalogKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UsageDto>>;
    public usage(catalogKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UsageDto>>;
    public usage(catalogKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (catalogKey === null || catalogKey === undefined) {
            throw new Error('Required parameter catalogKey was null or undefined when calling usage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UsageDto>('get',`${this.basePath}/admin/catalog/installations/${encodeURIComponent(String(catalogKey))}/usage`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
